import { z } from 'zod';

/**
 * Semaforo (GS3): so atividade, sem compromissos (voluntariado). Verde =
 * transmitiu nos ultimos 14 dias, amarelo = 15 a 30, vermelho = mais de 30.
 * "Sem contacto" = o padrinho nao fala com o afilhado ha mais de 30 dias
 * (mensagem dele na conversa ou relatorio entregue). "Relatorio em atraso"
 * vem da GS2.
 */

const datetimeSchema = z.string().datetime({ offset: true });

export const GREEN_MAX_DAYS = 14;
export const YELLOW_MAX_DAYS = 30;
export const NO_CONTACT_DAYS = 30;

export const activityLightSchema = z.enum(['green', 'yellow', 'red']);
export type ActivityLight = z.infer<typeof activityLightSchema>;

export function activityLight(daysWithoutStream: number): ActivityLight {
  if (daysWithoutStream <= GREEN_MAX_DAYS) return 'green';
  if (daysWithoutStream <= YELLOW_MAX_DAYS) return 'yellow';
  return 'red';
}

export const semaforoSchema = z.object({
  /** `null` = sem numeros da Twitch, ou nao esta ativo (pausa, saiu). */
  activity: activityLightSchema.nullable(),
  /** A ultima vez que o padrinho falou com ele (mensagem ou relatorio). */
  lastContactAt: datetimeSchema.nullable(),
  noContact: z.boolean(),
  checkupOverdue: z.boolean(),
});
export type Semaforo = z.infer<typeof semaforoSchema>;
